import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LineitemConfiguratorPageRoutingModule } from './lineitem-configurator-routing.module';

import { LineitemConfiguratorPage } from './lineitem-configurator.page';

import { SalonMonsterLoadMaskModule } from '../../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../../components/smr-tap-retry/smr-tap-retry.module';
import { StylistPickerModule } from '../../../components/stylist-picker/stylist-picker.module';

import { SharedModule } from '../../../shared.module';
import { MaskitoModule } from '@maskito/angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LineitemConfiguratorPageRoutingModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    StylistPickerModule,
    SharedModule,
    MaskitoModule,
    ReactiveFormsModule
  ],
  declarations: [LineitemConfiguratorPage]
})
export class LineitemConfiguratorPageModule {}
